import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_BLOCK_CHAT, API_CLEAR_CHAT, API_DELETE_CHAT } from "../api/chat.service";
import axiosInstance from "../api/axios.instance";

const initialState = {
  allotedAgent: {
    mob: null,
    displayName: "",
    agentId: "",
    role: "",
  },
  chatId: null,
  user: {},
  loading: false,
  isImageSelect: false,
  isProductSelect: false,
  isFileSelect: false,
  image: null,
  isVideoSelect: false,
  isRecAudioSelect: false,
  video: null,
  agentSearchItem: null,
  forwardModalAgentSearchItem: null,
  document: [],
  fileSending: false,
  isUserSelected: false,
  ticketStatusFilter: "",
  forwardModalTicketStatusFilter: "",
  showQuickNotes: false,
  filesLength: 0,
  filesLengthWarning: false,
  quickNotes: [],
  forwardMessagesFlag: false,
  forwardMessages: {},
  selectedForwardMessagesContent: [],
  clickedForwardFirstMessageId: null,
  replyMessage: false,
  messageForReply : {},
  repliedMessageFlag:false,
  files: [],
  uploadlock: false,
  selectedAgent : null,
  agentChatStatus: 'all',
};

export const deleteChat = createAsyncThunk(
  "enqChat/deleteChat",
  async (mobNo, thunkAPI) => {
    try {
      await axiosInstance.delete(API_DELETE_CHAT(mobNo));
      return mobNo;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const blockUnblockChat = createAsyncThunk(
  "enqChat/blockUnblockChat",
  async(payload, thunkAPI) =>{
    try {
       await axiosInstance.post(API_BLOCK_CHAT(),payload );
       return payload.blockStatus;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
)
export const clearChat = createAsyncThunk(
  "enqChat/clearChat",
  async(mobNo, thunkAPI) =>{
    try {
       await axiosInstance.delete(API_CLEAR_CHAT(mobNo));
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
)
const enqChatSlice = createSlice({
  name: "enqChat",
  initialState,
  reducers: {
    ChangeAgentChatStatus(state,action){
      state.agentChatStatus = action.payload;
    },
    changeAllotedAgent(state, action) {
      state.allotedAgent = action.payload;
    },
    changeUser(state, action) {
      state.user = action.payload;
      state.chatId = state.allotedAgent.mob + "-" + action.payload.phone;
    },
    resetChatUser(state) {
      state.user = initialState.user;
      state.chatId = initialState.chatId;
    },
    setImage(state, action) {
      state.image = action.payload;
    },
    setFiles(state, action) {
      state.files = action.payload;
    },
    updateFiles(state,action){
      state.files = state.files?.map(item =>{
        if(item.id == action.payload.id) return action.payload;
        else return item
      })
    },
    showFilelimitWarning(state, action) {
      state.filesLength = action.payload.filesLength;
      state.filesLengthWarning = action.payload.filesLengthWarning;
    },
    deleteFiles(state, action) {
      state.files = state.files.filter((x) => x?.id !== action.payload);
      if (state.files.length === 0) {
        state.isFileSelect = false;
      }
    },
    setIsImageSelected(state, action) {
      state.isImageSelect = action.payload;
    },
    setIsFileSelect(state, action) {
      state.isFileSelect = action.payload;
    },
    setVideo(state, action) {
      state.video = action.payload;
    },
    setDocument(state, action) {
      state.document = action.payload;
    },
    setFileSending(state, action) {
      state.fileSending = action.payload;
    },
    clearfiles(state) {
      state.files = initialState.files;
    },
    setIsVideoSelected(state, action) {
      state.isVideoSelect = action.payload;
    },
    setIsProductSelected(state, action) {
      state.isProductSelect = action.payload;
    },
    changeAgentSearchtUser(state, action) {
      state.agentSearchItem = action.payload?.toLowerCase();
    },
    changeForwardModalAgentSearchtUser(state, action) {
      state.forwardModalAgentSearchItem = action.payload?.toLowerCase();
    },
    changeIsUserSelected(state, action) {
      state.isUserSelected = action.payload;
    },
    changeTicketStatusFilter(state, action) {
      state.ticketStatusFilter = action.payload;
    },
    changeAgentFilter(state, action) {
      state.selectedAgent = action.payload;
    },
    changeForwardModalTicketStatusFilter(state, action) {
      state.forwardModalTicketStatusFilter = action.payload;
    },
    setlockUpload(state, action) {
      state.uploadlock = action.payload;
    },
    changeTicketID(state, action) {
      state.user.ticketId = action.payload;
    },
    updateUserStatus(state, { payload }) {
      state.user = { ...state.user, ...payload };
    },
    switchShowQuickNote(state) {
      state.showQuickNotes = !state.showQuickNotes;
    },
    changeIsRecAudioSelect(state, action) {
      state.isRecAudioSelect = action.payload;
    },

    setForwardMessage(state, action) {
      state.forwardMessagesFlag = action.payload.forwardMessagesFlag;
      state.forwardMessages = action.payload.forwardMessages;
      state.selectedForwardMessagesContent =
        action.payload.selectedForwardMessagesContent;
    },
    clearForwardMessage(state) {
      state.forwardMessagesFlag = false;
      state.forwardMessages = {};
      state.selectedForwardMessagesContent = [];
      state.clickedForwardFirstMessageId = null;
    },
    setForwardFirstMessageId(state, action) {
      state.clickedForwardFirstMessageId =
        action.payload.clickedForwardFirstMessageId;
    },
    clearForwardFirstMessageId(state, action) {
      state.clickedForwardFirstMessageId = null;
    },
    setReplyMessage(state, action) {
      
      state.replyMessage = action?.payload?.replyMessage;
      state.messageForReply = action?.payload?.messageForReply
      state.repliedMessageFlag = action?.payload?.repliedMessageFlag
      
    },
    clearReplyMessage(state) {
      state.replyMessage = false;
      state.messageForReply = {}
    },
    clearRepliedMessageFlag(state) {
      state.repliedMessageFlag = false;
    },
  },
  extraReducers:(builder)=> {
    builder.addCase(deleteChat.fulfilled, (state)=>{
      state.user = initialState.user;
      state.chatId = initialState.chatId;
    });
    builder.addCase(blockUnblockChat.fulfilled, (state,action)=>{
      
      state.user = {
        ...state.user,
        isOptOut:action.payload === "block" 
      }
    })
  },
});

export const {
  changeUser,
  setDocument,
  setFileSending,
  clearfiles,
  setIsFileSelect,
  setIsImageSelected,
  setIsProductSelected,
  setVideo,
  setIsVideoSelected,
  setImage,
  setFiles,
  showFilelimitWarning,
  deleteFiles,
  setlockUpload,
  changeAllotedAgent,
  changeAgentSearchtUser,
  changeForwardModalAgentSearchtUser,
  changeIsUserSelected,
  changeTicketStatusFilter,
  changeForwardModalTicketStatusFilter,
  updateUserStatus,
  changeTicketID,
  resetChatUser,
  switchShowQuickNote,
  changeIsRecAudioSelect,
  setForwardMessage,
  clearForwardMessage,
  setForwardFirstMessageId,
  clearForwardFirstMessageId,
  setReplyMessage,
  clearReplyMessage,
  clearRepliedMessageFlag,
  changeAgentFilter,
  updateFiles,
  ChangeAgentChatStatus,
} = enqChatSlice.actions;

export default enqChatSlice.reducer;
